import { Provider, InjectionToken, Type } from '@angular/core';
import {
  BimplusWebSdkFeature,
  BimplusWebsdkFeatures,
} from '../../interfaces/bimplus-websdk/interfaces';
import { Observable } from 'rxjs';
import { Api } from 'bimplus-websdk';

export interface WithEmbeddedValidationFeature extends BimplusWebSdkFeature {
  kind: BimplusWebsdkFeatures.EmbeddedTokenValidation;
  providers: Provider[];
  deps: InjectionToken<Api>[];
}

export const TOKEN_VALIDATION = new InjectionToken<() => Observable<string | null>>(
  'TOKEN_VALIDATION'
);

export interface TokenValidationConfig {
  signInType: Type<unknown>;
}
